export const getDelta = (now?: string, past?: string): number => parseFloat(now ?? '0') - parseFloat(past ?? '0') || 0

export const getPercentChange = (now?: string, past?: string) => {
  const n = parseFloat(now ?? '0')
  const p = parseFloat(past ?? '0')
  if (!isFinite(p) || p === 0) return 0
  return ((n - p) / p) * 100
}

/**
 * gets the amoutn difference plus the % change in change itself (second order change)
 * @param {*} valueNow
 * @param {*} value24HoursAgo
 * @param {*} value48HoursAgo
 */
export const get2DayChange = (valueNow: string, value24HoursAgo: string, value48HoursAgo: string): [number, number] => {
  // get volume info for both 24 hour periods
  const currentChange = parseFloat(valueNow) - parseFloat(value24HoursAgo)
  const previousChange = parseFloat(value24HoursAgo) - parseFloat(value48HoursAgo)
  const adjustedPercentChange = ((currentChange - previousChange) / previousChange) * 100
  if (isNaN(adjustedPercentChange) || !isFinite(adjustedPercentChange)) {
    return [currentChange, 0]
  }
  return [currentChange, adjustedPercentChange]
}
